import Page from "../Common/Page";
import React from "react";
import {
  Form,
  Select,
  Button,
  Row,
  Col,
  Table,
  Space,
  InputNumber,
  Modal,
  message,
} from "antd";
import { JudgmentUnitSelecter } from "../Components/JudgmentUnitSelecter";
import { Messages } from "../Common/ValidateMessages";
import { http } from "../Common/http";
import { AuthContext } from "../Auth/Auth";
import { getSubjectOptions, SelectOptionData } from "../Common/Utils";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { CommonMasterSelect } from "../Components/CommonMasterSelect";

const { Option } = Select;
const { confirm } = Modal;

interface StateType {
  defaultFy: string;
  subjectOptions: SelectOptionData[];
  subject: string;
  InterviewGroupData: any[];
}

type GroupNoDataList = {
  applicantId: string;
  groupNo: string;
};

interface PostSearchRequestData {
  fy: string;
  judgementUnitId: string;
  subjectId: string;
}

interface PostSearchData {
  JudgementUnitId: string;
  SubjectId: string;
  InterviewGroupData: GroupNoDataList[];
}

interface InterviewGroupDataFromServer {
  errorType: number;
  errorSeq: number;
  interviewGroupList: [];
}

class CreateInterviewGroup extends React.Component<any, StateType> {
  static contextType = AuthContext;

  private _page: React.RefObject<Page>;
  private _formRef: React.RefObject<any>;

  constructor(props: any, context) {
    super(props, context);
    this._page = React.createRef<Page>();
    this._formRef = React.createRef();
    this.state = {
      defaultFy: context.user.currentYear.toString(),
      subjectOptions: [],
      subject: "",
      InterviewGroupData: [],
    };
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit = async (e) => {
    let formValues: any;
    // 検索
    if (e.currentTarget.value === "search") {
      try {
        formValues = await this._formRef.current.validateFields([
          "judgmentUnit",
          "subject",
        ]);
        await this.doSearch(formValues);
      } catch (errorInfo) {
        console.log("Failed:", errorInfo);
        return;
      }
    }
    // 新規にグループを自動作成
    else if (e.currentTarget.value === "group") {
      try {
        formValues = await this._formRef.current.validateFields([
          "groupCnt",
          "preGroup",
        ]);
        confirm({
          title: Messages["CON-006"],
          icon: <ExclamationCircleOutlined />,
          onOk: () => {
            this.doGroup(formValues);
          },
          onCancel: () => {},
        });
      } catch (errorInfo) {
        console.log("Failed:", errorInfo);
        return;
      }
    }
    // 確定
    else if (e.currentTarget.value === "submit") {
      try {
        confirm({
          title: Messages["CON-030"],
          icon: <ExclamationCircleOutlined />,
          onOk: async () => {
            formValues = await this._formRef.current.validateFields([
              "judgmentUnit",
              "subject",
            ]);
            await this.doSave(formValues);
          },
          onCancel: () => {},
        });
      } catch (errorInfo) {
        console.log("Failed:", errorInfo);
        return;
      }
    }
  };

  // 確定
  doSave = async (formValues: any) => {
    let errFlg = false;
    let MsgData = "";
    const datas: any[] = this.state.InterviewGroupData;
    const postDatas: GroupNoDataList[] = [];

    let maxGroupNo = 0;
    let groupNoMap = new Map<any, boolean>();
    for (let i = 0; i < datas.length; i++) {
      const keyname = "group_" + datas[i].applicantId;
      const groupNo = this._formRef.current.getFieldValue(keyname);

      if (
        groupNo === undefined ||
        groupNo == null ||
        groupNo === "" ||
        groupNo === 0
      ) {
        errFlg = true;
        MsgData = Messages["ERR-035"];
        break;
      } else {
        groupNoMap.set(Number(groupNo), true);
        if (groupNo > maxGroupNo) {
          maxGroupNo = groupNo;
        }
      }

      const dataItem: GroupNoDataList = {
        applicantId: datas[i].applicantId,
        groupNo: groupNo,
      };
      postDatas.push(dataItem);
    }

    if (!errFlg) {
      for (let i = 1; i <= maxGroupNo; i++) {
        if (
          groupNoMap.get(i) === undefined ||
          groupNoMap.get(i) == null ||
          groupNoMap.get(i) === false
        ) {
          console.log("error", i);
          errFlg = true;
          MsgData = Messages["ERR-070"];
          break;
        }
      }
    }

    if (errFlg) {
      message.error(MsgData);
    } else {
      try {
        this._page.current?.setState({ isPageLoading: true });

        const postData: PostSearchData = {
          JudgementUnitId: formValues.judgmentUnit,
          SubjectId: formValues.subject,
          InterviewGroupData: postDatas,
        };
        const result = await http<InterviewGroupDataFromServer, PostSearchData>(
          {
            path: "/InterviewGroup/Import",
            method: "post",
            body: postData,
            accessToken: this.context.accessToken,
          }
        );
        if (result.ok) {
          message.info(Messages["MSG-003"]);
        } else {
          message.error(Messages["ERR-037"]);
        }
        this._page.current?.setState({ isPageLoading: false });
      } catch (error) {
        console.log(error);
        message.error(Messages["ERR-037"]);
      }
    }
  };

  // 自動グループ作成
  doGroup = async (formValues: any) => {
    try {
      let hasPreGroup = false;
      let hasGroupCnt = false;
      if (
        !(
          formValues["preGroup"] === undefined ||
          formValues["preGroup"] == null ||
          formValues["preGroup"].length === 0
        )
      ) {
        hasPreGroup = true;
      }
      if (
        !(
          formValues["groupCnt"] === undefined ||
          formValues["groupCnt"] == null ||
          formValues["groupCnt"].length === 0
        )
      ) {
        hasGroupCnt = true;
      }

      if (!hasPreGroup && !hasGroupCnt) {
        message.error(Messages["ERR-057"]);
        return;
      }

      if (hasPreGroup && hasGroupCnt) {
        message.error(Messages["ERR-027"]);
        return;
      }

      const datas: any[] = this.state.InterviewGroupData;
      let cntPerGroup = formValues["preGroup"];
      if (hasGroupCnt) {
        cntPerGroup = Math.ceil(datas.length / formValues["groupCnt"]);
      }
      if (cntPerGroup > 10) {
        message.error(Messages["ERR-026"]);
        return;
      }
      this._page.current?.setState({ isPageLoading: true });

      let groupNo = 1;
      let cnt = 0;
      for (let i = 0; i < datas.length; i++) {
        if (cnt === cntPerGroup) {
          groupNo++;
          cnt = 0;
        }
        const keyname = "group_" + datas[i]["applicantId"];
        this._formRef.current.setFieldsValue({
          [keyname]: groupNo,
        });
        cnt++;
      }

      this._page.current?.setState({ isPageLoading: false });
    } catch (error) {
      console.log(error);
      message.error(Messages["ERR-020"]);
      this._page.current?.setState({ isPageLoading: false });
    }
  };

  // 検索処理
  doSearch = async (formValues: any) => {
    try {
      this._page.current?.setState({ isPageLoading: true });

      this.setState({
        InterviewGroupData: [],
      });

      const _PostSearchData: PostSearchRequestData = {
        fy: this.state.defaultFy,
        judgementUnitId: formValues.judgmentUnit,
        subjectId: formValues.subject,
      };
      const result = await http<
        InterviewGroupDataFromServer,
        PostSearchRequestData
      >({
        path: "/InterviewGroup/Search",
        method: "post",
        body: _PostSearchData,
        accessToken: this.context.accessToken,
      });

      if (result.ok && result.body) {
        if (result.body.errorType === 0) {
          this.setState({
            InterviewGroupData: result.body.interviewGroupList,
          });
        } else if (result.body.errorType === 1) {
          message.error(Messages["ERR-067"]);
        } else if (result.body.errorType === 2) {
          message.error(`${result.body.errorSeq}${Messages["ERR-068"]}`);
        }
      } else {
        message.error(Messages["ERR-030"]);
      }
      this._page.current?.setState({ isPageLoading: false });
    } catch (error) {
      console.log(error);
      message.error(Messages["ERR-030"]);
      this._page.current?.setState({ isPageLoading: false });
    }
  };

  onFormValueChange = () => {};

  onSubjectChanged = (newValue) => {
    this.setState({
      subject: newValue,
      InterviewGroupData: [],
    });
  };

  onFyChange = (newValue) => {
    this.setState({
      defaultFy: newValue.value,
      InterviewGroupData: [],
    });
  };

  onJudgmentUnitSelected = async (record: any) => {
    if (
      record &&
      record.fyJudgementUnitId &&
      record.fyJudgementUnitId.length > 0
    ) {
      const subjectOptions = await getSubjectOptions(
        this.context.accessToken,
        record.fyJudgementUnitId,
        undefined,
        undefined,
        "1"
      );
      this.setState({
        subjectOptions: subjectOptions,
        subject: "",
        InterviewGroupData: [],
      });
    } else {
      this.setState({
        subjectOptions: [],
        subject: "",
        InterviewGroupData: [],
      });
    }
  };

  fixedColumns = [
    {
      title: <div className="table-title">連番</div>,
      key: "no",
      render: (value: any, item: any, index: number) => (
        <span>{index + 1}</span>
      ),
      width: 100,
    },
    {
      title: <div className="table-title">グループNo.</div>,
      key: "groupNo",
      width: 100,
      render: (value: any, item: any, index: number) => {
        return (
          <Form.Item
            name={`group_${item.applicantId}`}
            initialValue={item.groupNo}
          >
            <InputNumber min={1} keyboard={true} max={9999} />
          </Form.Item>
        );
      },
      shouldCellUpdate: (record, prevRecord) => {
        return true;
      },
    },
    {
      title: <div className="table-title">氏名</div>,
      key: "name",
      render: (value: any, item: any, index: number) =>
        `${item.sei} ${item.mei}`,
      width: 200,
    },
    {
      title: <div className="table-title">受験番号</div>,
      key: "examineesNumbers",
      dataIndex: "examineesNumbers",
      width: 200,
    },
    {
      title: <div className="table-title">出身高校</div>,
      key: "highSchool",
      dataIndex: "highSchool",
    },
  ];

  render() {
    return (
      <Page title="志願者面接グループ作成" ref={this._page}>
        <div className="data_content">
          <Form
            colon={false}
            labelAlign="left"
            name="CreateInterviewGroup"
            onValuesChange={this.onFormValueChange}
            autoComplete="off"
            layout="horizontal"
            labelCol={{ span: 8 }}
            initialValues={{
              fy: { value: this.state.defaultFy },
            }}
            fields={[{ name: "subject", value: this.state.subject }]}
            ref={this._formRef}
          >
            <div className="search_form" style={{ width: "100%" }}>
              <Row>
                <Col span={6}>
                  <Form.Item
                    label="入試年度"
                    name="fy"
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                  >
                    <CommonMasterSelect
                      allowClear={false}
                      masterType={31}
                      onChange={this.onFyChange}
                    />
                  </Form.Item>
                </Col>
                <Col span={18}>
                  <Form.Item
                    labelCol={{ span: 2 }}
                    label="判定単位"
                    name="judgmentUnit"
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                  >
                    <JudgmentUnitSelecter
                      width={500}
                      defaultFy={this.state.defaultFy}
                      onDataSelect={this.onJudgmentUnitSelected}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col span={6}>
                  <Form.Item
                    label="科目"
                    name="subject"
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                  >
                    <Select
                      style={{ width: 200 }}
                      allowClear={false}
                      onChange={this.onSubjectChanged}
                    >
                      {this.state.subjectOptions.length > 0 &&
                        this.state.subjectOptions.map((data: any) => (
                          <Option key={data.id} value={data.id}>
                            {data.name}
                          </Option>
                        ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={12}></Col>
                <Col span={6}>
                  <Form.Item>
                    <Button
                      type="primary"
                      value="search"
                      onClick={(e) => this.handleSubmit(e)}
                    >
                      表示
                    </Button>
                  </Form.Item>
                </Col>
              </Row>

              <Row
                style={{
                  display:
                    this.state.InterviewGroupData.length === 0 ? "none" : "",
                }}
              >
                <Col span={24}>新規にグループを自動作成(し直したい場合)</Col>
              </Row>
              <Row
                style={{
                  display:
                    this.state.InterviewGroupData.length === 0 ? "none" : "",
                }}
              >
                <Col span={4}>
                  <Form.Item
                    name="groupCnt"
                    label="グループ数"
                    labelCol={{ span: 10 }}
                  >
                    <InputNumber
                      min={1}
                      max={1000}
                      // onChange={onChange}
                    />
                  </Form.Item>
                </Col>
                <Col span={1}>または</Col>
                <Col span={12}>
                  <Form.Item
                    name="preGroup"
                    label="1グループ辺り人数"
                    labelCol={{ span: 5 }}
                  >
                    <InputNumber
                      min={1}
                      max={10}
                      // onChange={onChange}
                    />
                  </Form.Item>
                </Col>
                <Col span={4}>
                  <Form.Item>
                    <Button
                      disabled={this.state.InterviewGroupData.length === 0}
                      type="primary"
                      value="group"
                      onClick={(e) => this.handleSubmit(e)}
                    >
                      志願者面接グループ自動作成
                    </Button>
                  </Form.Item>
                </Col>
              </Row>
            </div>
            <Space direction="vertical" style={{ width: "100%" }}>
              <ul className="resultCount">
                <li className="grey">
                  件数<span>{this.state.InterviewGroupData.length}</span>
                </li>
              </ul>
              <Table
                columns={this.fixedColumns}
                dataSource={this.state.InterviewGroupData}
                pagination={false}
                scroll={{ y: "calc(100vh - 420px)" }}
                bordered
              />
            </Space>
            <Row>
              <Col span={24}>
                <br />
                <Form.Item>
                  <div style={{ float: "right" }}>
                    <Button
                      disabled={this.state.InterviewGroupData.length === 0}
                      type="primary"
                      value="submit"
                      style={{ marginRight: "100px" }}
                      onClick={(e) => this.handleSubmit(e)}
                    >
                      確定
                    </Button>
                  </div>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </div>
      </Page>
    );
  }
}
export default CreateInterviewGroup;
